var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelivery = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "2.1%",
    stopColor: "#03EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "29.3%",
    stopColor: "#24D2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.4%",
    stopColor: "#3CBDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79.6%",
    stopColor: "#4AB0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4FACFE"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    transform: "translate(-17 -237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 251c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM30 251c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM47.053 239.52a.988.988 0 0 0-.879-.52H41v1.888h4.569L48.244 246l1.756-.848-2.947-5.632z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 254h9v2h-9zM26.902 254h-8.804c-.607 0-1.098.448-1.098 1s.491 1 1.098 1h8.804c.607 0 1.098-.448 1.098-1s-.491-1-1.098-1zM52.783 247.26l-3.18-2.38a1.071 1.071 0 0 0-.815-.364H41.28v-6.576c0-.52-.462-.94-1.032-.94H18.033c-.57 0-1.033.42-1.033.94 0 .518.462.939 1.033.939h21.183v6.577c0 .519.462.94 1.032.94h8.034l2.652 1.762v5.963h-2.858c-.57 0-1.033.42-1.033.94 0 .518.463.939 1.033.939h3.891c.57 0 1.033-.42 1.033-.94v-7.224a.888.888 0 0 0-.217-.576zM25.94 249h-4.88c-.585 0-1.06.448-1.06 1s.475 1 1.06 1h4.88c.585 0 1.06-.448 1.06-1s-.475-1-1.06-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.05 245h-8.1c-.525 0-.95.448-.95 1s.425 1 .95 1h8.1c.525 0 .95-.448.95-1s-.425-1-.95-1zM29.05 241h-8.1c-.525 0-.95.448-.95 1s.425 1 .95 1h8.1c.525 0 .95-.448.95-1s-.425-1-.95-1z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelivery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delivery.339bfda4e8ab5254e2535bdfd8613fec.svg";